
import { defineComponent, onUnmounted, onMounted, ref } from 'vue'
import { createNamespacedHelpers } from 'vuex-composition-helpers'
import session from '../services/session'

const { useGetters: useUserGetters, useActions: useUserActions } = createNamespacedHelpers('user')

export default defineComponent({
  name: 'IdleTimeoutWarning',
  emits: ['onDialogClose'],
  setup() {
    const { user } = useUserGetters(['user'])
    const { getMe, logout, sessionTimeout } = useUserActions(['getMe', 'logout', 'sessionTimeout'])
    const show = ref(false)

    onMounted(() => {
      document.addEventListener('ensureSessionModalOpen', handleEnsureModalOpen)
      document.addEventListener('ensureSessionModalClosed', handleEnsureModalClosed)
      document.addEventListener('ensureSessionLoggedOut', handleEnsureSessionLoggedOut)
    })

    onUnmounted(() => {
      session.pollCookie()
      document.removeEventListener('ensureSessionModalOpen', handleEnsureModalOpen)
      document.removeEventListener('ensureSessionModalClosed', handleEnsureModalClosed)
      document.removeEventListener('ensureSessionLoggedOut', handleEnsureSessionLoggedOut)
    })

    function handleEnsureModalOpen() {
      show.value = true
    }

    function handleEnsureModalClosed() {
      show.value = false
    }

    function handleEnsureSessionLoggedOut() {
      show.value = false
      if (user.value) {
        sessionTimeout()
      }
    }

    async function handleDialogClose(option?: 'logOut' | 'keepSession') {
      show.value = false
      if (!option) return
      try {
        session.cancelPoll()
        if (option === 'logOut') {
          await logout()
        } else if (option === 'keepSession') {
          await getMe()
        }
      } finally {
        session.pollCookie()
      }
    }

    return {
      show,
      handleDialogClose
    }
  }
})
